export default __webpack_public_path__ + "static/media/smallColoredLogoAcium.f71ade32.svg";